import { h, Component } from 'preact';
import classNames from 'classnames';
import { connect } from 'preact-redux';
import { categoriesSelector } from 'app/desktop/selectors/categories';
import CategoryFlyoutItem from 'app/desktop/components/categories/CategoryFlyoutItem';
import {
  showCategoriesFlyout,
  showCategoryFlyoutItem,
} from 'app/desktop/actions/navbar';
import { checkExperiment } from 'app/common/actions/flags';

export class CategoriesFlyout extends Component {
  constructor(props) {
    super(props);

    this.renderL1CatAndOCcasions = this.renderL1CatAndOCcasions.bind(this);
    this.renderL1Cats = this.renderL1Cats.bind(this);
    this.renderOccasionLinks = this.renderOccasionLinks.bind(this);
    this.getNewBadge = this.getNewBadge.bind(this);
  }

  componentDidMount() {
    this.props.checkExperiment('enableMoviesLink');
  }

  getNewBadge(key) {
    if (key === 'movies') return <div className="new-badge">New</div>;
    return null;
  }

  renderL1Cats(cat) {
    const { id, key, url, bhw, label } = cat;
    const { activeCategory } = this.props;
    return (
      <div
        className={classNames('l1-cat icon-arrow-right-large', {
          'current-tab': id === activeCategory,
        })}
        key={key}
        id={id}
        data-bhw={bhw}
        onMouseOver={() => this.props.showCategoryFlyoutItem(id)}
        onFocus={() => this.props.showCategoryFlyoutItem(id)}
        onClick={url}
        role="button"
        tabIndex="0"
      >
        {label}
      </div>
    );
  }

  renderOccasionLinks(occasion) {
    const { key, url, label, bhw } = occasion;
    const { flags } = this.props;
    if (key === 'movies' && !flags.experiments.enableMoviesLink) {
      return null;
    }
    return (
      <div
        className={classNames(`occasion-links`, { movies: key === 'movies' })}
        key={key}
        bhw={bhw}
      >
        <a className="occasionLinks" href={url}>
          {label}
          {this.getNewBadge(key)}
        </a>
      </div>
    );
  }

  renderL1CatAndOCcasions() {
    const { catFlyouts, occasionLinks } = this.props;
    return (
      <div className="categories-column" key="categories-column">
        {Array.isArray(catFlyouts) &&
          catFlyouts.map(category => this.renderL1Cats(category))}
        {occasionLinks && occasionLinks.map(this.renderOccasionLinks)}
      </div>
    );
  }

  render() {
    const { isCategoriesFlyoutDisplayed, catFlyouts } = this.props;

    return (
      <div
        className={classNames(
          { 'ls-hide': !isCategoriesFlyoutDisplayed },
          `cat-flyout-wrapper`
        )}
      >
        <div className="cat-flyout-inner">
          <div
            id="categories-flyout"
            className="categories-flyout"
            aria-labelledby="categories"
            onMouseLeave={this.props.showCategoriesFlyout}
          >
            {this.renderL1CatAndOCcasions()}
            {catFlyouts && <CategoryFlyoutItem />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  categoriesSelector,
  { showCategoriesFlyout, showCategoryFlyoutItem, checkExperiment }
)(CategoriesFlyout);
